import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import NotificationConfigModalContent from "../ProductCatalogue/ModalContent/NotificationConfigModalContent";
import ReusableDropdown from "../../Component/BasicComponents/Dropdowns/Dropdown";
import { useGetNotificationList } from "./NotificationRepo";
import { downloadExcelGet } from "../../utils/ExcelDownload";
import { COLORS } from "../../constants/colors";
import { BASE_URL } from "../../Api/config";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { showToast } from "../../utils/toastUtils";
type Props = {};

const filterOptions = [
  {
    label: "Organization",
    options: [
      { id: "All", label: "All" },
      { id: "HR", label: "HR" },
      { id: "Finance", label: "Finance" },
      { id: "IT", label: "IT" },
    ],
  },
];
const data = [
  { id: 1, name: "Oliver Hansen" },
  { id: 2, name: "Van Henry" },
  { id: 3, name: "April Tucker" },
  { id: 4, name: "Ralph Hubbard" },
  { id: 5, name: "Omar Alexander" },
];

const NotificationConfigure = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chechStatusSubmitAndUpdate, setchechStatusSubmitAndUpdate] =
    useState<string>("");
  const [selectNotification, setSelectNotification] = useState<any>(null);
  const [exceLoading, setExcelLoading] = useState<boolean>(false);

  const [filter, setFilter] = useState({
    start: 1,
    length: 10,
    search: "",
  });

  // API
  const { data, isLoading, isSuccess } = useGetNotificationList({
    enable: true,
    params: {
      start: filter.start,
      length: filter.length,
      search: filter.search,
    },
  });

  const NotificationTableData =
    !isLoading &&
    isSuccess &&
    data?.data?.data?.map((item: any) => ({
      id: item?.NotificationConfigurationId,
      notitype: item?.NotificationType || "-",
      notitime: item?.NotificationTime || "-",
      notisubject: item?.NotificationSubject || "-",
      notimessage: item?.NotificationMessage || "-",
      redirectscreen: item?.RedirectScreen || "-",
      Role: item?.Role || "-",
      IsEnabled: item?.IsEnabled || "-",
    }));

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
    setchechStatusSubmitAndUpdate((prev) =>
      prev === "Submit" ? "Update" : "Submit"
    );
    setSelectNotification(null);
  };

  const handleClose = () => setIsModalOpen(false);
  const handleUpdate = (row: any, status: string) => {
    console.log("Notification Configuration row", row);
    setSelectNotification(row);
    setchechStatusSubmitAndUpdate(status);
    setIsModalOpen(true);
  };

  const handleChangeRowPerPage = (limit: any, pageNo: any) => {
    setFilter((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };

  const notificationConfigDataColumns = [
    {
      name: "Notification Type",
      selector: (row: { notitype: number | string }) => row.notitype,
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Notification Time",
      selector: (row: { notitime: string }) => row.notitime,
      sortable: true,
      width: "180px",
    },
    {
      name: "Notification Subject",
      selector: (row: { notisubject: string }) => row.notisubject,
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "Notification Message",
      selector: (row: { notimessage: string }) => row.notimessage,
      sortable: true,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "Redirect Screen",
      selector: (row: { redirectscreen: string }) => row.redirectscreen,
      sortable: true,
      width: "200px",
    },
    {
      name: "Action",
      cell: (row: any) => (
        <button
          onClick={() => handleUpdate(row, "Update")}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];

  const handlePagination = (pageNo: number) => {
    setFilter((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const downloadExcel = async () => {
    const appToken = localStorage.getItem("Apptoken") || "";
    const params: Record<string, any> = {
      ...(filter.search == "" ? {} : { search: filter.search }),
    };
    const querytring = new URLSearchParams(params).toString();
    const apiEndpoint = `${BASE_URL}${API_ENDPOINTS.CONFIGURATION.GET_EXCEL_DOWNLOAD_NOTI_CONFI}${querytring}`;
    const fileName = "NotificationConfiguration.xlsx";
    try {
      setExcelLoading(true);
      const response = await downloadExcelGet({
        apiEndpoint,
        fileName,
        appToken,
      });
      if(response.success){
        showToast.success(response.message);
        setExcelLoading(false);
      }
    } catch (error: any) {
      console.log('Error while downloading the excel in notification configuration ');
    } finally {
      setExcelLoading(false);
    }
  };
  return (
    <div className="p-2">
      <PageHeader
        title="Notification Configure"
        buttons={[
          {
            label: "+ Add New",
            onClick: () => toggleModal(),
            color:COLORS.primary,
          },
          {
            label:exceLoading?"Loading..." : "Excel",
            onClick: () => downloadExcel(),
            color:exceLoading ? COLORS.disable : COLORS.primary,
          },
          // {
          //   label: "CSV",
          //   onClick: () => alert("Action 3 clicked"),
          //   color: "#43B9B2",
          // },  
        ]}
      />

      <BasicDataTable
        Title="Notification Configure List"
        data={(!isLoading && isSuccess && NotificationTableData) || []}
        columns={notificationConfigDataColumns}
        filterOptions={filterOptions}
        // headerContent={<HeaderContent />}
        showSpinner={isLoading}
        search={true}
        handleSearch={(e: any) =>
          setFilter((prev) => ({
            ...prev,
            search: e,
          }))
        }
        onChangeRowsPerPage={(limit: any, pageNo: any) => {
          handleChangeRowPerPage(limit, pageNo);
        }}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        paginationTotalRows={data?.data?.recordsTotal}
      />
      <RouteModal
        toggle={toggleModal}
        isOpen={isModalOpen}
        title={
          chechStatusSubmitAndUpdate !== "Submit"
            ? "Edit Notification Configuration"
            : "Add Notification Configuration"
        }
        size="lg"
        content={
          <NotificationConfigModalContent
            handleClose={handleClose}
            chechStatusSubmitAndUpdate={chechStatusSubmitAndUpdate}
            selectNotification={selectNotification}
          />
        }
      />
    </div>
  );
};

export default NotificationConfigure;
